import { render, staticRenderFns } from "./PropertySubCategory.vue?vue&type=template&id=4c317aa4&scoped=true&"
import script from "./PropertySubCategory.vue?vue&type=script&lang=js&"
export * from "./PropertySubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c317aa4",
  null
  
)

export default component.exports